import React from 'react';

const Title: React.FC< { children: React.ReactNode, className?: string }> = ( { children, className }) => {

  return <div className={`text-[0.938rem] ${className || ''}`}>{children}</div>
}

export { Title }